<template>
  <div>
    <generic-table
      ref="datatable"
      :title="$t('campaigns')"
      :columns="columns"
      :column_search="true"
      resource_url="/emarketing/campaign/datatables"
    >
      <template v-slot:buttons>
        <button class="button is-secondary is-rounded" @click="create">
          <span class="icon"><i class="fa fa-plus"></i></span>
          <span>{{ $t("create") }}</span>
        </button>
      </template>
    </generic-table>
    <campaign-modal ref="campaign_modal" @success="refresh" />
    <messages-modal ref="messages_modal" />
  </div>
</template>

<script>
import GenericTable from "@/components/generic_table/GenericTable.vue";
import {
  generate_datatables_buttons,
  confirm_deletion_dialog,
  del,
  put,
  error_message,
  success_message,
  format_date_time,
  format_date,
} from "@/utils";
import CampaignModal from "./campaign_modal/Index.vue";
import MessagesModal from "../messages_modal/Index.vue";
import { truncate } from "lodash";

export default {
  name: "CampaignDatatable",
  components: { GenericTable, CampaignModal, MessagesModal },
  data() {
    let v = this;
    return {
      columns: [
        {
          title: v.$t("date"),
          searchable: false,
          // width: "25%",
          data: (row) => {
            return format_date(row.create_date);
          },
        },
        {
          title: v.$t("send date"),
          searchable: false,
          // width: "25%",
          data: (row) => {
            return format_date(row.send_date);
          },
        },
        {
          title: v.$t("name"),
          name: "name",
          searchable: true,
          data: (row) => {
            return row.name;
          },
        },
        {
          title: v.$t("settings"),
          searchable: false,
          data: (row) => {
            return `<div class="title is-6">${row.datasource.name}</div>
            <div class="subtitle is-6">${row.outbox_template.name}</div>`;
            // <div class="subtitle is-7">${JSON.stringify(
            //   row.settings,
            //   null,
            //   2
            // )}</div>`;
          },
        },
        // {
        //   title: v.$t("data"),
        //   searchable: false,
        //   // width: "55%",
        //   data: (row) => {
        //     // return truncate(JSON.stringify(row), { length: 65 });
        //     return `<pre>${JSON.stringify(row, null, 2)}</pre>`;
        //   },
        // },
        {
          title: v.$t("options"),
          // width: "20%",
          searchable: false,
          data: (row) => {
            return generate_datatables_buttons([
              {
                args: { uuid: row.uuid },
                tooltip: v.$t("edit"),
                icon: "fa fa-edit",
                icon_class: "is-small",
                click: function (e) {
                  // console.log("edit order", e.detail.uuid);
                  v.$refs.campaign_modal.edit_modal(e.detail.uuid);
                },
              },
              {
                args: { uuid: row.uuid },
                tooltip: v.$t("messages"),
                icon: "fa fa-envelope",
                icon_class: "is-small",
                click: function (e) {
                  // console.log("edit order", e.detail.uuid);
                  v.$refs.messages_modal.show_modal(e.detail.uuid);
                },
              },
              {
                args: { uuid: row.uuid },
                tooltip: v.$t("execute"),
                icon: "fa fa-bolt",
                icon_class: "is-small",
                click: function (e) {
                  let uuid = e.detail.uuid;
                  confirm_deletion_dialog(
                    v.$t("are you sure to execute campaign?"),
                    v,
                    () => {
                      put("/emarketing/campaign/execute", { uuid: uuid })
                        .then((r) => {
                          // console.log(r);
                          success_message(v.$t("campaign executed"));
                        })
                        .catch((error) => {
                          error_message(error);
                        });
                    }
                  );
                },
              },
              {
                args: { uuid: row.uuid },
                tooltip: v.$t("delete"),
                icon: "fa fa-trash",
                icon_class: "is-small has-text-danger",
                click: (e) => {
                  let uuid = e.detail.uuid;
                  confirm_deletion_dialog(
                    v.$t("are you sure to delete campaign?"),
                    v,
                    () => {
                      del("/emarketing/campaign", { uuid: uuid })
                        .then(() => {
                          v.refresh();
                        })
                        .catch((error) => {
                          error_message(error);
                        });
                    }
                  );
                },
              },
            ]);
          },
        },
      ],
    };
  },
  methods: {
    // format_date_time,
    create() {
      let v = this;
      v.$refs.campaign_modal.show_modal();
    },
    refresh() {
      let v = this;
      v.$refs.datatable.refresh();
    },
  },
  mounted() {
    this.refresh();
  },
};
</script>

<style></style>
